import './style.scss'
import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

export interface ModalProps {
    open: boolean
    onClose: () => void
    title?: string
    children: React.ReactNode
    maxWidth?: string
    className?: string
}

export const Modal: React.FC<ModalProps> = ({
                                                open, onClose, title, children, maxWidth = '52rem', className = '',
                                            }) => {
    useEffect(() => {
        if (!open) return
        const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
        document.addEventListener('keydown', onKey)
        document.body.style.overflow = 'hidden'
        return () => {
            document.removeEventListener('keydown', onKey)
            document.body.style.overflow = ''
        }
    }, [open, onClose])

    if (!open) return null

    return createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div
                className={`modal ${className}`}
                style={{ maxWidth }}
                onClick={(e) => e.stopPropagation()}
            >
                {title && (
                    <div className="modal__header">
                        <span className="modal__title">{title}</span>
                        <button type="button" className="modal__close" aria-label="Close" onClick={onClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                        </button>
                    </div>
                )}
                <div className="modal__body">{children}</div>
            </div>
        </div>,
        document.body,
    )
}

export default Modal